import { createApp } from 'vue'
import './style.css'
import './static/iconfont.css'
import './style/common.scss'
import App from './App.vue'
import { router } from '@/router'
import pinia from '@/store'
import utils from '@/utils'
import xbbError from '@xbb/xbb-error'

import xbbSdk from 'xbb-sdk'

import { registerVant } from './vant'
import 'vant/lib/index.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

window.utils === undefined && (window.utils = utils)

const initApp = () => {
  const app = createApp(App)
  app.use(router)
  app.use(pinia)
  app.use(ElementPlus)

  registerVant(app)
  app.mount('#app')

  xbbError.monitorInit(app)
}

// iframe嵌套的部分直接初始化app
if (
  window.location.hash.includes('book') ||
  window.location.hash.includes('describe') ||
  window.location.hash.includes('iframe') ||
  window?.uni
) {
  initApp()
} else {
  xbbSdk
    .ready((val) => {
      console.log('云叩初始化完成', val)
      utils.xbbLocalStorageRemove('corpid')
      utils.xbbLocalStorageRemove('userId')
      utils.xbbLocalStorageRemove('xbbAccessToken')
      if (val.userInfo.corpid) {
        utils.xbbLocalStorageSet('corpid', val.userInfo.corpid)
        utils.xbbLocalStorageSet('ai_corpid', val.userInfo.corpid)
        // 通过嵌入到销帮帮内的方式，偶尔会出现corpid缓存丢失，其他缓存还在。单独存一个ai_corpid试试，值与corpid一致
      }
      if (val.userInfo.userId) {
        utils.xbbLocalStorageSet('userId', val.userInfo.userId)
        utils.xbbLocalStorageSet('ai_userId', val.userInfo.userId)
        // 同ai_corpid
      }
      if (val.userInfo.xbbAccessToken) {
        utils.xbbLocalStorageSet('xbbAccessToken', val.userInfo.xbbAccessToken)
        utils.xbbLocalStorageSet('ai_xbbAccessToken', val.userInfo.xbbAccessToken)
        // 同ai_corpid
      }
      utils.xbbLocalStorageSet('userName', val.userInfo.userName)
      utils.xbbLocalStorageSet('parantOrigin', val.parantOrigin)
      utils.xbbLocalStorageSet('systemKind', val.systemKind)
      if (val.isSeeNewUserTips) {
        utils.xbbLocalStorageSet('isSeeNewUserTips', val.isSeeNewUserTips)
      }
      if (val.isCloseStartTips) {
        utils.xbbLocalStorageSet('isCloseStartTips', val.isCloseStartTips)
      }
      utils.xbbLocalStorageSet('wxIsBindApp', val.wxIsBindApp)
      utils.xbbLocalStorageSet('cloudPath', val.path)
      utils.xbbLocalStorageSet('aiBoardCurrentMenuIsBeta', val.aiBoardCurrentMenuIsBeta)
    })
    .catch((err) => {
      console.log(err)
    })
    .finally(() => {
      console.log('xbbSdk 判断结束 再渲染页面')
      initApp()
    })
}
